import styled from 'styled-components'
import ParagraphProps from './interfaces/Paragraph'

const Paragraph = styled.p`
  text-align: ${({ textAlign }: ParagraphProps) => textAlign};
`

export default Paragraph
